import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_LEGS_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-bulgarian-split-squat",
    "name": "哑铃保加利亚分腿蹲（臀主导）",
    "group": "legs",
    "subCategory": "glutes",
    "equipment": "dumbbell",
    "pattern": "后脚抬高髋主导分腿蹲",
    "legacyIds": [
      "bulgarian-split-squat",
      "fanjue-bulgarian-glute"
    ],
    "sourceId": "course-20261008-four-way-03-04",
    "targetMuscles": [
      "臀大肌",
      "股四头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-single-leg-dumbbell-dl",
    "name": "单腿哑铃罗马尼亚硬拉",
    "group": "legs",
    "subCategory": "hamstrings",
    "equipment": "dumbbell",
    "pattern": "单腿哑铃髋铰链",
    "legacyIds": [
      "single-leg-dumbbell-dl",
      "single-leg-dl-glute"
    ],
    "sourceId": "course-20261008-four-way-03-06",
    "targetMuscles": [
      "腘绳肌",
      "臀大肌"
    ],
    "evidence": "仅肌群旧分类/热身标记不同，器械和运动模式相同"
  },
  {
    "id": "library-dumbbell-lunge",
    "name": "哑铃弓步蹲",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "dumbbell",
    "pattern": "哑铃弓步膝髋伸",
    "legacyIds": [
      "dumbbell-lunge"
    ],
    "sourceId": "course-20261008-four-way-03-05",
    "targetMuscles": [
      "股四头肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-standing-calf-raise",
    "name": "徒手站姿提踵",
    "group": "legs",
    "subCategory": "calves",
    "equipment": "bodyweight",
    "pattern": "站姿踝跖屈",
    "legacyIds": [
      "standing-calf-raise"
    ],
    "sourceId": "course-20261008-home-03-07",
    "targetMuscles": [
      "腓肠肌",
      "比目鱼肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-bulgarian-split-squat-v2",
    "name": "徒手保加利亚分腿蹲",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "bodyweight",
    "pattern": "徒手后脚抬高分腿蹲",
    "legacyIds": [
      "home-bulgarian-split-squat-v2",
      "ksw-single-leg-bulgarian",
      "threeway-bulgarian-squat",
      "fanjue-bulgarian-leg"
    ],
    "sourceId": "course-20261008-home-03-04",
    "targetMuscles": [
      "股四头肌",
      "臀大肌"
    ],
    "evidence": "主线程核对居家、凯圣王、三分化及焚诀演示徒手姿态；双哑铃膝/髋主导另保留"
  },
  {
    "id": "library-home-glute-bridge-v2",
    "name": "单腿臀桥",
    "group": "legs",
    "subCategory": "glutes",
    "equipment": "bodyweight",
    "pattern": "单腿髋伸",
    "legacyIds": [
      "home-glute-bridge-v2"
    ],
    "sourceId": "course-20261008-home-03-06",
    "targetMuscles": [
      "臀大肌",
      "腘绳肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-goblet-squat",
    "name": "哑铃高脚杯深蹲",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "dumbbell",
    "pattern": "高脚杯膝髋伸",
    "legacyIds": [
      "home-goblet-squat"
    ],
    "sourceId": "course-20261008-home-03-03",
    "targetMuscles": [
      "股四头肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-barbell-rdl",
    "name": "杠铃罗马尼亚硬拉",
    "group": "legs",
    "subCategory": "hamstrings",
    "equipment": "barbell",
    "pattern": "双腿杠铃髋铰链",
    "legacyIds": [
      "ksw-barbell-rdl"
    ],
    "sourceId": "course-20261008-ksw-collection-03-13",
    "targetMuscles": [
      "腘绳肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-lying-leg-curl",
    "name": "俯卧器械腿弯举",
    "group": "legs",
    "subCategory": "hamstrings",
    "equipment": "machine",
    "pattern": "俯卧器械膝屈",
    "legacyIds": [
      "threeway-lying-leg-curl"
    ],
    "sourceId": "course-20261008-personal-06-07",
    "targetMuscles": [
      "腘绳肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-rhino-squat",
    "name": "犀牛蹲（腰带深蹲）",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "machine",
    "pattern": "腰带负重膝髋伸",
    "legacyIds": [
      "threeway-rhino-squat"
    ],
    "sourceId": "course-20261008-fanjue-plan-16-05",
    "targetMuscles": [
      "股四头肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s6-adductor",
    "name": "坐姿器械髋内收",
    "group": "legs",
    "subCategory": "inner-thigh",
    "equipment": "machine",
    "pattern": "坐姿器械髋内收",
    "legacyIds": [
      "personal-s6-adductor"
    ],
    "sourceId": "course-20261008-personal-06-03",
    "targetMuscles": [
      "髋内收肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s6-bulgarian-squat",
    "name": "哑铃保加利亚分腿蹲（膝主导）",
    "group": "legs",
    "subCategory": "quadriceps",
    "equipment": "dumbbell",
    "pattern": "后脚抬高膝主导分腿蹲",
    "legacyIds": [
      "personal-s6-bulgarian-squat",
      "fanjue-bulgarian-squat"
    ],
    "sourceId": "course-20261008-personal-06-04",
    "targetMuscles": [
      "股四头肌",
      "臀大肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
